document.body.addEventListener("htmx:afterSwap", (e) => {
	// Only run for post appends
	if (e.detail.target.id !== "posts") return;

	const newPosts = e.detail.target.querySelectorAll(".htmx-added");
	newPosts.forEach((post, i) => {
		post.classList.add("opacity-0", "translate-y-4", "transition-all", "duration-500", "ease-out");

		// Stagger each post
		setTimeout(() => {
			post.classList.remove("opacity-0", "translate-y-4");
			post.classList.add("opacity-100", "translate-y-0");
		}, i * 120); // adjust for faster/slower stagger
	});
});
